import { render } from "./SliderGallery.vue?vue&type=template&id=9637b080"
import script from "./SliderGallery.vue?vue&type=script&lang=js"
export * from "./SliderGallery.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\iran\\iranrpm\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__